import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IdentifyStockFileModel} from '../../../models/IdentifyStockFile-model';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-user-input-selection',
  templateUrl: './user-input-selection.component.html',
  styleUrls: ['./user-input-selection.component.css']
})
export class UserInputSelectionComponent {

  @Input() stockFileDTO: IdentifyStockFileModel;
  @Input() selectedOptions: { key: string; value: boolean; disabled: boolean }[] = [];

  @Output() activeOption = new EventEmitter<{ key: string; value: boolean; disabled: boolean }>();
  @Output() stockFileBlobName = new EventEmitter<string>();

  @Input() ecuBuildNameControl: FormControl | null;

  /** Match & Tune dialog: Paper layout (toggles + footer). */
  @Input() paperLayout = false;

  /** Unknown ECU: scrollable "Other tunings" region (GC1-0). */
  @Input() scrollOtherSection = false;

  @Input() unidentified = false;

  isPerformanceOption(key: string): boolean {
    const k = (key || '').toLowerCase();
    return k.includes('stage') || k.includes('vmax') || k.includes('decat');
  }

  performanceItems(): { key: string; value: boolean; disabled: boolean }[] {
    return this.selectedOptions.filter(o => this.isPerformanceOption(o.key));
  }

  otherItems(): { key: string; value: boolean; disabled: boolean }[] {
    return this.selectedOptions.filter(o => !this.isPerformanceOption(o.key));
  }

  selectedCount(): number {
    return this.selectedOptions.filter(o => o.value).length;
  }

  setOptionToActive(option: { key: string; value: boolean; disabled: boolean }): void {
    this.activeOption.emit(option);
  }

  /**
   * Disables a toggle when it must not be clickable. Stage 1/2/3 exclusivity is enforced in
   * {@link UserInputsComponent.setOptionToActive} (turning one on clears the others), so stage
   * switches stay enabled and users can switch stage in one click without two stages staying on.
   */
  checkValidityOfOptions(option: { key: string; value: boolean; disabled: boolean }): boolean {
    return option.disabled === true;
  }

  requestFileTune(stockFileBlobName: string): void {
    this.stockFileBlobName.emit(stockFileBlobName);
  }

  anyOptionsSelected(): boolean {
    for (const option of this.selectedOptions) {
      if (option.value) {
        return false;
      }
    }
    return true;
  }

  requestDisabled(): boolean {
    if (this.anyOptionsSelected()) {
      return true;
    }
    if (this.ecuBuildNameControl && this.unidentified) {
      return this.ecuBuildNameControl.invalid;
    }
    return false;
  }

  footerSummary(): string {
    const n = this.selectedCount();
    const t = this.selectedOptions.length;
    if (this.unidentified) {
      return `${n} tuning(s) selected · ECU build required`;
    }
    return `${n} of ${t} tunings selected`;
  }
}
